import { ScheduledPostSettings } from 'api/clients/ScheduledPostsClient'
import { MediaObject } from 'types'

const wordPressContentValidator = (_content: string): string[] => {
  return []
}

const wordPressFileValidator = (_files: MediaObject[]): string[] => {
  return []
}

const wordPressVideosSizeValidator = (_files: MediaObject[]): string[] => {
  return []
}

const wordPressImageSizeValidator = (_files: MediaObject[]): string[] => {
  return []
}

const wordPressDurationValidator = (_files: MediaObject[]): string[] => {
  return []
}

const wordPressAspectRatioValidator = (_files: MediaObject[]): string[] => {
  return []
}

const wordPressFormatsValidator = (_files: MediaObject[]): string[] => {
  return []
}

const wordpressVideosValidator = (_files: MediaObject[]): string[] => {
  return []
}

const wordpressPostSettingsValidator = (_settings?: ScheduledPostSettings): string[] => {
  return []
}

const wordPressValidators = {
  validateContent: wordPressContentValidator,
  validateFiles: wordPressFileValidator,
  validateVideosSize: wordPressVideosSizeValidator,
  validateImagesSize: wordPressImageSizeValidator,
  validateVideosDuration: wordPressDurationValidator,
  validateVideosAspectRatio: wordPressAspectRatioValidator,
  validateVideosFormat: wordPressFormatsValidator,
  validateVideosCount: wordpressVideosValidator,
  validatePostSettings: wordpressPostSettingsValidator,
}

export default wordPressValidators
